import React from "react";

const AlcoholSVG: React.VFC<{}> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="322"
            height="236"
            viewBox="0 0 322 236"
        >
            <g
                id="グループ_24305"
                data-name="グループ 24305"
                transform="translate(-27 -208)"
            >
                <text
                    id="ビール_500ml"
                    data-name="ビール
500ml"
                    transform="translate(79 303)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-15.25" y="0">
                        ビール
                    </tspan>
                    <tspan x="-18.685" y="14">
                        500ml
                    </tspan>
                </text>
                <text
                    id="ウイスキー_60ml"
                    data-name="ウイスキー
60ml"
                    transform="translate(79 429)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-26.45" y="0">
                        ウイスキー
                    </tspan>
                    <tspan x="-14.725" y="14">
                        60ml
                    </tspan>
                </text>
                <text
                    id="缶チューハイ_350ml"
                    data-name="缶チューハイ
350ml"
                    transform="translate(188 303)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-31.65" y="0">
                        缶チューハイ
                    </tspan>
                    <tspan x="-18.685" y="14">
                        350ml
                    </tspan>
                </text>
                <text
                    id="日本酒_180ml"
                    data-name="日本酒
180ml"
                    transform="translate(188 429)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-15.8" y="0">
                        日本酒
                    </tspan>
                    <tspan x="-18.685" y="14">
                        180ml
                    </tspan>
                </text>
                <text
                    id="ワイン_180ml"
                    data-name="ワイン
180ml"
                    transform="translate(297 303)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-15.8" y="0">
                        ワイン
                    </tspan>
                    <tspan x="-18.685" y="14">
                        180ml
                    </tspan>
                </text>
                <text
                    id="焼酎_110ml"
                    data-name="焼酎
110ml"
                    transform="translate(297 429)"
                    font-size="10"
                    font-family="HiraginoSans-W6, Hiragino Sans"
                    letter-spacing="0.08em"
                    opacity="0.9"
                >
                    <tspan x="-10.4" y="0">
                        焼酎
                    </tspan>
                    <tspan x="-18.685" y="14">
                        110ml
                    </tspan>
                </text>
                <g id="support_drink_1" transform="translate(27 208)">
                    <rect
                        id="長方形_13445"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24270"
                        data-name="グループ 24270"
                        transform="translate(-9 -215)"
                    >
                        <path
                            id="パス_9682"
                            data-name="パス 9682"
                            d="M8,0l4-5H32l4,5V47l-3,3H11L8,47Z"
                            transform="translate(39 235)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <rect
                            id="長方形_13429"
                            data-name="長方形 13429"
                            width="20"
                            height="4"
                            transform="translate(51 226)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9683"
                            data-name="パス 9683"
                            d="M-13135,6645.971h27.94"
                            transform="translate(13182 -6364)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <g
                            id="パス_9692"
                            data-name="パス 9692"
                            transform="translate(50 237)"
                            fill="#fff"
                        >
                            <path
                                d="M 19.69732666015625 41.5 L 2.302672863006592 41.5 L 0.5 39.69323348999023 L 0.5 2.306768178939819 L 2.302672863006592 0.5 L 19.69732666015625 0.5 L 21.5 2.306768178939819 L 21.5 39.69323348999023 L 19.69732666015625 41.5 Z"
                                stroke="none"
                            />
                            <path
                                d="M 2.510116577148438 1 L 1 2.513545989990234 L 1 39.48645401000977 L 2.510116577148438 41 L 19.48988342285156 41 L 21 39.48645401000977 L 21 2.513545989990234 L 19.48988342285156 1 L 2.510116577148438 1 M 2.095239639282227 0 L 19.90476036071777 0 L 22 2.099998474121094 L 22 39.90000152587891 L 19.90476036071777 42 L 2.095239639282227 42 L 0 39.90000152587891 L 0 2.099998474121094 L 2.095239639282227 0 Z"
                                stroke="none"
                                fill="#000"
                            />
                        </g>
                    </g>
                </g>
                <g id="support_drink_2" transform="translate(136 208)">
                    <rect
                        id="長方形_13445-2"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24271"
                        data-name="グループ 24271"
                        transform="translate(-136 -215)"
                    >
                        <path
                            id="パス_9681"
                            data-name="パス 9681"
                            d="M8,0l4-5H32l4,5V37l-3,3H11L8,37Z"
                            transform="translate(166 245)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <rect
                            id="長方形_13428"
                            data-name="長方形 13428"
                            width="20"
                            height="4"
                            transform="translate(178 236)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <g
                            id="楕円形_5"
                            data-name="楕円形 5"
                            transform="translate(184 261)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        >
                            <circle cx="7" cy="7" r="7" stroke="none" />
                            <circle cx="7" cy="7" r="6.5" fill="none" />
                        </g>
                        <g
                            id="楕円形_4"
                            data-name="楕円形 4"
                            transform="translate(177 254)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        >
                            <circle cx="8" cy="8" r="8" stroke="none" />
                            <circle cx="8" cy="8" r="7.5" fill="none" />
                        </g>
                    </g>
                </g>
                <g id="support_drink_3" transform="translate(245 208)">
                    <rect
                        id="長方形_13445-3"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24272"
                        data-name="グループ 24272"
                        transform="translate(-271.973 -215)"
                    >
                        <path
                            id="パス_9686"
                            data-name="パス 9686"
                            d="M1.805,4H21.663l1.805,19.894c0,8.4-5.254,15.213-11.734,15.213S0,32.3,0,23.894Z"
                            transform="translate(311.973 226)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9684"
                            data-name="パス 9684"
                            d="M-12873,6637.984h23.436"
                            transform="translate(13185.004 -6353.002)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9685"
                            data-name="パス 9685"
                            d="M0,0H19.893"
                            transform="translate(323.723 265.108) rotate(90)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9687"
                            data-name="パス 9687"
                            d="M-12871.852,6607.686h23.215"
                            transform="translate(13184.031 -6361.67)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                    </g>
                </g>
                <g id="support_drink_4" transform="translate(27 334)">
                    <rect
                        id="長方形_13445-4"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24273"
                        data-name="グループ 24273"
                        transform="translate(-29 -306)"
                    >
                        <g
                            id="パス_9688"
                            data-name="パス 9688"
                            transform="translate(62 336)"
                            fill="#fff"
                        >
                            <path
                                d="M 35.52437210083008 39.5 L 2.475628614425659 39.5 L 0.5256285071372986 0.5 L 37.47437286376953 0.5 L 35.52437210083008 39.5 Z"
                                stroke="none"
                            />
                            <path
                                d="M 1.051246643066406 1 L 2.951248168945312 39 L 35.04875183105469 39 L 36.94875335693359 1 L 1.051246643066406 1 M 0 0 L 38 0 L 36 40 L 2 40 L 0 0 Z"
                                stroke="none"
                                fill="#000"
                            />
                        </g>
                        <path
                            id="パス_9689"
                            data-name="パス 9689"
                            d="M-13104.439,6752.15h-32.775"
                            transform="translate(13202 -6387)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9690"
                            data-name="パス 9690"
                            d="M-13130.574,6728.291l-2.193,13.853,11.4,7.465,12.643-10.465-7.45-11.845Z"
                            transform="translate(13202 -6387)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9691"
                            data-name="パス 9691"
                            d="M-13138.238,6734.668h34.521"
                            transform="translate(13202 -6387)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                    </g>
                </g>
                <g id="support_drink_5" transform="translate(136 334)">
                    <rect
                        id="長方形_13445-5"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24274"
                        data-name="グループ 24274"
                        transform="translate(-135 -306)"
                    >
                        <g
                            id="長方形_13432"
                            data-name="長方形 13432"
                            transform="translate(174 371)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        >
                            <rect width="15" height="5" stroke="none" />
                            <rect
                                x="0.5"
                                y="0.5"
                                width="14"
                                height="4"
                                fill="none"
                            />
                        </g>
                        <g
                            id="パス_9693"
                            data-name="パス 9693"
                            transform="translate(166 330)"
                            fill="#fff"
                        >
                            <path
                                d="M 17 42.5 L 13 42.5 C 9.661129951477051 42.5 6.52209997177124 41.19977188110352 4.16117000579834 38.83882904052734 C 1.800230026245117 36.47790145874023 0.5 33.33887100219727 0.5 30 L 0.5 28 C 0.5 24.68367004394531 2.883780002593994 19.97001075744629 5.189070224761963 15.41154956817627 C 7.406010150909424 11.02779960632324 9.5 6.88716983795166 9.5 4 L 9.5 1.774899959564209 L 9.5 1 C 9.5 -1.082491278648376 8.3338623046875 -4.129793167114258 7.761499404907227 -5.5 L 22.23033905029297 -5.5 C 21.65364646911621 -4.150331020355225 20.5 -1.178072094917297 20.5 1 L 20.5 1.858800053596497 L 20.5 4 C 20.5 6.844329833984375 22.66975021362305 11.26371955871582 24.96689987182617 15.94258975982666 C 27.19551086425781 20.48185920715332 29.5 25.17568016052246 29.5 28 L 29.5 30 C 29.5 33.33887100219727 28.19976997375488 36.47790145874023 25.83883094787598 38.83882904052734 C 23.4778995513916 41.19977188110352 20.33886909484863 42.5 17 42.5 Z"
                                stroke="none"
                            />
                            <path
                                d="M 17 42 C 20.20532035827637 42 23.21878051757812 40.75178146362305 25.48527908325195 38.48527908325195 C 27.75177955627441 36.21878051757812 29 33.20531845092773 29 30 L 29 28 C 29 25.29179954528809 26.72153091430664 20.65097045898438 24.51807975769043 16.16295051574707 C 22.19461059570312 11.43047046661377 20 6.960450172424316 20 4 L 20 1 C 20 -0.9362251162528992 20.86424446105957 -3.448495388031006 21.48347473144531 -5 L 8.502880096435547 -5 C 9.121641159057617 -3.423814535140991 10 -0.8589345812797546 10 1 L 10 4 C 10 7.006410121917725 7.879869937896729 11.19873046875 5.635260105133057 15.63720035552979 C 3.356420040130615 20.14333915710449 1 24.80290985107422 1 28 L 1 30 C 1 33.20531845092773 2.248219966888428 36.21878051757812 4.51471996307373 38.48527908325195 C 6.781219959259033 40.75178146362305 9.794679641723633 42 13 42 L 17 42 M 17 43 L 13 43 C 5.820300102233887 43 -1.77635683940025e-15 37.1796989440918 -1.77635683940025e-15 30 L -1.77635683940025e-15 31.57338714599609 C -1.77635683940025e-15 31.57338714599609 -1.77635683940025e-15 30.76727485656738 -1.77635683940025e-15 28 C -1.77635683940025e-15 21.36761093139648 9 9.742589950561523 9 4 C 9 1.773975253105164 9 1.217045307159424 9 1.217045307159424 L 9 1.774896621704102 C 9 1.774896621704102 9 1.588570594787598 9 1 C 9 -1.623270034790039 7 -6 7 -6 L 23 -6 C 23 -6 21 -1.762719988822937 21 1 C 21 1.657124042510986 21 1.858802437782288 21 1.858802437782288 L 21 1.35013473033905 C 21 1.35013473033905 21 1.876376748085022 21 4 C 21 9.525400161743164 30 22.19162940979004 30 28 C 30 28.86536979675293 30 29.51715850830078 30 30 C 30 37.1796989440918 24.17970085144043 43 17 43 Z M 30 31.22586250305176 C 30 31.22586250305176 30 30.91919898986816 30 30 L 30 31.22586250305176 Z"
                                stroke="none"
                                fill="#000"
                            />
                        </g>
                        <g
                            id="長方形_13430"
                            data-name="長方形 13430"
                            transform="translate(188 356)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        >
                            <path
                                d="M0,0H20a0,0,0,0,1,0,0V7A10,10,0,0,1,10,17h0A10,10,0,0,1,0,7V0A0,0,0,0,1,0,0Z"
                                stroke="none"
                            />
                            <path
                                d="M.952.5h18.1A.452.452,0,0,1,19.5.952V7A9.5,9.5,0,0,1,10,16.5h0A9.5,9.5,0,0,1,.5,7V.952A.452.452,0,0,1,.952.5Z"
                                fill="none"
                            />
                        </g>
                        <g
                            id="長方形_13431"
                            data-name="長方形 13431"
                            transform="translate(193 371)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        >
                            <rect width="11" height="5" stroke="none" />
                            <rect
                                x="0.5"
                                y="0.5"
                                width="10"
                                height="4"
                                fill="none"
                            />
                        </g>
                    </g>
                </g>
                <g id="support_drink_6" transform="translate(245 334)">
                    <rect
                        id="長方形_13445-6"
                        data-name="長方形 13445"
                        width="104"
                        height="78"
                        fill="rgba(255,255,255,0)"
                    />
                    <g
                        id="グループ_24275"
                        data-name="グループ 24275"
                        transform="translate(-272 -325)"
                    >
                        <rect
                            id="長方形_13433"
                            data-name="長方形 13433"
                            width="28"
                            height="6"
                            transform="translate(310 389)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9694"
                            data-name="パス 9694"
                            d="M-1,4H39L32.986,38.062,4.992,38Z"
                            transform="translate(305 351)"
                            fill="#fff"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9695"
                            data-name="パス 9695"
                            d="M-12863.53,6742.5h11.736"
                            transform="translate(13192.496 -6370.278)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                        <path
                            id="パス_9696"
                            data-name="パス 9696"
                            d="M-12863.531,6742.5h11.088"
                            transform="translate(13192.496 -6364.722)"
                            fill="none"
                            stroke="#000"
                            stroke-width="1"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default AlcoholSVG;
